import NewInputField from "../../DesignSystem/Inputs/NewInputField";
import NewMobileNumberInput from "../../DesignSystem/Inputs/NewMobileNumberInput";
import RadioGroup from "../../DesignSystem/Inputs/RadioGroup";
import ReferenceForm from "./ReferenceForm";

const PERMISSION_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const PersonalReferenceDetails = ({
  form,
  update,
  validationErrors,
  isReferenceNotRequired = false,
}) => (
  <>
    <NewInputField label="Type of Reference" value="Personal Reference" disabled />
    <div className="grid2 gap-m">
      <NewInputField
        label="Full Name"
        value={form.fullName}
        onChange={(event) => update("fullName", event.target.value)}
        required={!isReferenceNotRequired}
        error={validationErrors.fullName ? "Full Name is required." : ""}
      />
      <NewInputField
        label="Relationship to Referee"
        value={form.relationship}
        onChange={(event) => update("relationship", event.target.value)}
      />
    </div>
    <div className="grid2 gap-m">
      <NewInputField
        label="Dates Known"
        value={form.datesKnown}
        onChange={(event) => update("datesKnown", event.target.value)}
        required={!isReferenceNotRequired}
        error={validationErrors.datesKnown ? "This date information is required." : ""}
      />
      <NewMobileNumberInput
        label="Contact Number"
        value={form.contactNumber}
        onChange={(value) => update("contactNumber", value)}
      />
    </div>
    <RadioGroup
      name="personalAdviserPermission"
      label="Adviser’s permission to contact for reference"
      options={PERMISSION_OPTIONS}
      value={form.adviserPermission}
      onChange={(event) => update("adviserPermission", event.target.value)}
      required={!isReferenceNotRequired}
      inline
      error={validationErrors.adviserPermission}
      deselectable
    />
  </>
);

const PersonalReferenceForm = (props) => (
  <ReferenceForm
    {...props}
    referenceKind="personal"
    DetailsFields={PersonalReferenceDetails}
  />
);

export default PersonalReferenceForm;
